<template>
  <div class="catalogue">
    <div class="section-page-title">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h1 class="page-title">{{ pageTitle }}</h1>
          </div>
        </div>
      </div>
    </div>
    <b-tabs
      v-model="active"
      lazy
      nav-class="catalogue-tabs"
      content-class="pt-4"
    >
      <b-tab v-if="showTenders" title="Paslaugos">
        <Services />
      </b-tab>
      <template v-else><Services /></template>

      <b-tab v-if="showTenders" title="Konkursai">
        <Tenders />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Services from './services'
// eslint-disable-next-line import/extensions
import Tenders from '../../../../Tenders/Resources/js/components/tenders.vue'

export default {
  name: 'CatalogueTabs',
  components: { Services, Tenders },

  props: {
    showTenders: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      // 0 = Paslaugos, 1 = Konkursai
      active: 0,
    }
  },

  computed: {
    pageTitle() {
      return this.active === 1 ? 'Konkursai' : 'Paslaugos'
    },
  },

  watch: {
    active(val) {
      if (typeof window === 'undefined') return
      const path = val === 1 ? '/konkursai' : '/'
      window.history.replaceState({}, '', path)
      document.title = this.pageTitle
    },
  },

  created() {
    this.syncFromURL()
    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', this.syncFromURL)
    }
  },

  destroyed() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('popstate', this.syncFromURL)
    }
  },

  methods: {
    syncFromURL() {
      if (typeof window === 'undefined') return

      const path = window.location.pathname
      this.active = /\/konkursai\/?$/.test(path) ? 1 : 0
      document.title = this.pageTitle
    },
  },
}
</script>

<style scoped>
.catalogue-tabs {
  justify-content: center;
}
</style>
